/**
 * The lead filter "In campaign" (PREC-4163): does this person hold a confirmed, retained
 * assignment to a native campaign on any list the caller may see?
 *
 * The name stays `assignedTo` and the param `list_person.campaignId`, the key the filter was saved
 * under while it was the row-level "Assigned to", so every saved view filter and drill-down link
 * still loads. Their meaning is now the person-wide one (approved in the ticket); the API claims
 * the filter by this name before the generic filter families
 * (`applyInCampaignFilter`, apps/api/src/list/helpers/filter-query).
 */
export const IN_CAMPAIGN_FILTER_NAME = "assignedTo";
export const IN_CAMPAIGN_FILTER_PARAM = "list_person.campaignId";

/** Include a campaign, exclude one, none at all, any at all. */
export const IN_CAMPAIGN_FILTER_OPERATORS = [
	"dropdownCustom",
	"dropdownCustomExclude",
	"isEmpty",
	"isNotEmpty",
] as const;

export type InCampaignFilterOperator = (typeof IN_CAMPAIGN_FILTER_OPERATORS)[number];

/**
 * A campaign option's readable label. Campaign names repeat across lists ("Default Campaign"), and
 * the options span every list the caller may see, so the label names the list too; the option's
 * id is the campaign's stable id, never its name.
 */
export function inCampaignOptionLabel(campaignName: string, listName: string | null): string {
	return listName ? `${campaignName} · ${listName}` : campaignName;
}
